import { Component, inject, input } from '@angular/core';
import {
	ApiRequestOrdering,
	ApiPaginatedResponse,
	VehicleModelSearchDto,
	ModulesEnum,
} from '@splitsecondconnect/ultramarine-shared';
import { Observable } from 'rxjs';

import { ListDisplaySectionItemComponent } from '../../../../shared/components/list-display-section/components/list-display-section-item/list-display-section-item.component';
import { SearchableStrategy } from '../../../../shared/models/searchable-strategy.model';
import { SelectItem } from '../../../../shared/models/select-item.type';
import { mapDtoToModelVehicleModels } from '../vehicles-record/components/vehicles-make-model/mappers/search-dto-to-model.mapper';
import { VehicleMakesService } from '../vehicles-record/components/vehicles-make-model/services/vehicle-makes.service';

@Component({
	selector: 'app-vehicle-model-selected-item',
	imports: [ListDisplaySectionItemComponent],
	host: {
		class: 'w-full',
	},
	template: `
		<app-list-display-section-item
			[svgIcon]="'label'"
			[plain]="true"
			class="w-full"
			[item]="item()"
			[module]="item().module">
		</app-list-display-section-item>
	`,
})
class VehicleModelSelectedItemComponent {
	item = input<SelectItem<VehicleModelSearchDto>>();
	plain = input<boolean>();
	moduleEnum = ModulesEnum;
}

export class VehicleModelSearchStrategy implements SearchableStrategy<VehicleModelSearchDto> {
	#vehicleModelsService = inject(VehicleMakesService);
	ordering: ApiRequestOrdering = {
		columnName: `vehicle-model.id`,
		direction: 'DESC',
	};

	getSearchResults(
		searchQuery: string,
		searchQueryIds: number[],
		pageSize: number,
		searchFilters: any,
		page: number,
		ordering: ApiRequestOrdering = this.ordering,
	): Observable<ApiPaginatedResponse<any[]>> {
		return this.#vehicleModelsService.getModelsSearchResults(
			searchQuery,
			searchQueryIds,
			pageSize,
			searchFilters,
			page,
		);
	}

	selectedItemDisplay = VehicleModelSelectedItemComponent;

	mapDtoToModel(
		items: VehicleModelSearchDto[],
	): SelectItem<VehicleModelSearchDto>[] {
		return mapDtoToModelVehicleModels(items);
	}
}
